import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import type { UseCase } from "./types";

interface ProductUseCasesProps {
  productKey: string;
  useCases: UseCase[];
}

export function ProductUseCases({ productKey, useCases }: ProductUseCasesProps) {
  const { t } = useTranslation();

  return (
    <section className="py-12 lg:py-28 bg-background">
      <div className="container mx-auto px-4 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-2xl mx-auto mb-14"
        >
          <h2 className="text-3xl md:text-4xl font-medium font-heading text-primary tracking-tight">
            {t(`productPages.${productKey}.useCases.title`)}
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {useCases.map((useCase, index) => (
            <motion.div
              key={useCase.titleKey}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.08 }}
              className="group relative bg-card rounded-xl border border-border p-6 hover:shadow-lg hover:border-primary/20 transition-all duration-300"
            >
              <div className="w-10 h-10 rounded-lg bg-coral/10 flex items-center justify-center mb-4 group-hover:bg-coral/20 transition-colors">
                <useCase.icon className="h-5 w-5 text-coral" />
              </div>
              <h3 className="text-base font-bold font-subheading text-foreground mb-2">
                {t(useCase.titleKey)}
              </h3>
              <p className="text-sm text-muted-foreground font-body leading-relaxed">
                {t(useCase.descriptionKey)}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
